// File: src/components/Hero.jsx   1
import React from "react";
import heroImg from "../images/banner.png";

const Hero = () => {
  return (
    <section className="hero" style={{ backgroundImage: `url(${heroImg})` }}>
      <div className="hero-left">
        <h1>Transmission Erection & EPC Solutions</h1>
        <p>Safe • Reliable • High Voltage Infrastructure Execution</p>
        <button
          className="btn-primary"
          onClick={() => document.getElementById("services").scrollIntoView({ behavior: "smooth" })}
        >
          Explore Services
        </button>
      </div>
    </section>
  );
};

export default Hero;